<template>
    <div>
        <el-row>
            <el-button>默认按钮</el-button>
            <el-button type="primary">主要按钮</el-button>
            <el-button type="success">成功按钮</el-button>
            <el-button type="info">信息按钮</el-button>
            <el-button type="warning">警告按钮</el-button>
            <el-button type="danger">危险按钮</el-button>
        </el-row>
        <hr>
        <el-row>
            <el-button round icon="el-icon-search" >圆角按钮</el-button>
            <el-button type="primary" icon="el-icon-edit" round>主要按钮</el-button>
            <el-button type="success" icon="el-icon-check" round>成功按钮</el-button>
            <el-button type="info" icon="el-icon-message" round>信息按钮</el-button>
            <el-button type="warning" icon="el-icon-star-off" round>警告按钮</el-button>
            <el-button type="danger" icon="el-icon-delete" round>危险按钮</el-button>
        </el-row>
        <hr>
        <el-table :data="tableData" border style="width: 100%">
            <el-table-column prop="生日" label="出生日期" width="180"></el-table-column>
            <el-table-column prop="姓名" label="姓名" width="180"></el-table-column>
            <el-table-column prop="住址" label="地址"></el-table-column>
        </el-table>
        <!-- Pagination 分页 -->
        <el-pagination background 
            layout="total,sizes, prev, pager, next, jumper" 
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :total="900">
        </el-pagination>

        <br>
        <!-- Dialog对话框 -->
        <el-button @click="dialogTableVisible = true">打开嵌套表格的 Dialog</el-button>

        <!-- Table -->
        <el-dialog title="收货地址" :visible.sync="dialogTableVisible">
            <el-table :data="gridData">
                <el-table-column property="date" label="日期" width="150"></el-table-column>
                <el-table-column property="name" label="姓名" width="200"></el-table-column>
                <el-table-column property="address" label="地址"></el-table-column>
            </el-table>
        </el-dialog>

        <!-- Dialog对话框-Form表单 -->
        <el-button @click="dialogFormVisible = true">打开嵌套Form的 Dialog</el-button>
        <el-dialog title="Form表单" :visible.sync="dialogFormVisible">
            <el-form ref="form" :model="form" label-width="80px">
                <el-form-item label="活动名称">
                <el-input v-model="form.名称"></el-input>
                </el-form-item>
                <el-form-item label="活动区域">
                <el-select v-model="form.区域" placeholder="请选择活动区域">
                    <el-option label="华东" value="上海"></el-option>
                    <el-option label="华北" value="北京"></el-option>
                </el-select>
                </el-form-item>
                <el-form-item label="活动时间">
                <el-col :span="11">
                    <el-date-picker type="date" placeholder="选择日期" v-model="form.日期" value-format="yyyy-MM-dd" style="width: 100%;"></el-date-picker>
                </el-col>
                <el-col class="line" :span="2">-</el-col>
                <el-col :span="11">
                    <el-time-picker type="time"  placeholder="选择时间" v-model="form.时间" value-format="HH:mm" style="width: 100%;"></el-time-picker>
                </el-col>
                </el-form-item>
                <el-form-item>
                <el-button type="primary" @click="onSubmit">提交</el-button>
                <el-button type="danger" @click="cancel">取消</el-button>
                </el-form-item>
            </el-form>
        </el-dialog>

        <el-button @click="goToExternalUrl('../index.html')">退出</el-button>

    </div>
</template>

<script>
export default {
    data () {
        return {
            tableData: [
                { 生日: '2016-05-02', 姓名: '王小虎', 住址: '上海市普陀区金沙江路 1518弄'
                }, {生日: '2016-05-04', 姓名: '王小虎', 住址: '上海市普陀区金沙江路 1517弄'
                }, {生日: '2016-05-01', 姓名: '王小虎', 住址: '上海市普陀区金沙江路 1519弄'
                }, {生日: '2016-05-03', 姓名: '王小虎', 住址: '上海市普陀区金沙江路 1516弄'
                }
            ],
            dialogTableVisible: false,
            gridData: [
                { date: "2016-05-02",name:"王小虎",address:"上海市普陀区金沙江路1518弄",
                },{date:"2016-05-04",name:"王小虎",address:"上海市普陀区金沙江路1517弄",
                },{date:"2016-05-01",name:"王小虎",address:"上海市普陀区金沙江路1519弄",
                },{date:"2016-05-03",name:"王小虎",address:"上海市普陀区金沙江路1516弄",
                },
            ],
            dialogFormVisible: false,
            form: {
                名称: '',
                区域: '',
                日期: '',
                时间: ''
            },
        }
    },
    methods: {
        handleSizeChange:function(val){
            alert("每页记录数变化" + val)
        },
        handleCurrentChange:function(val){
            alert("页码发生变化" + val)
        },
        onSubmit:function(){
            alert(JSON.stringify(this.form));
            // 关闭dialog
            this.dialogFormVisible = false;
        },
        cancel:function(){
            this.form = {名称: '', 区域: '', 日期: '', 时间: ''};
            // 关闭dialog
            this.dialogFormVisible = false;
        },
        goToExternalUrl(url) {
            window.location.href = url;
        }
    }
  }

</script>
<style>

</style>